<!-- CMS markets (e.g. en-US, es-US, zh-US): nav structure comes from Contentstack nav_header entries -->
@if (isCmsRoute) {
    @if (cmsNavData) {
        <ul class="dotcom-mobile-nav">
            @for (section of cmsNavData.navHeaders; track $index) {
                @if (isShopSection(section)) {
                    <li class="dotcom-mobile-nav__item">
                        <button class="dotcom-mobile-nav__trigger"
                                type="button"
                                (click)="toggleSection(-1)"
                                [attr.aria-expanded]="activeIndex === -1">
                            {{ formatNavLabel(section.header?.headerTitle ?? section.link?.label) }}
                            <i class="sidenav-chevron fa-solid fa-chevron-down"
                               [class.sidenav-chevron--open]="activeIndex === -1"></i>
                        </button>
                        @if (activeIndex === -1) {
                            <shop-nav-full-menu [mobile]="true" (closeMenu)="navigate()"></shop-nav-full-menu>
                        }
                    </li>
                <!-- Contentstack header entry: has a title + columns of links, renders as a collapsible accordion -->
                } @else if (section.header; as hdr) {
                    <li class="dotcom-mobile-nav__item">
                        <button class="dotcom-mobile-nav__trigger"
                                type="button"
                                (click)="toggleSection($index)"
                                [attr.aria-expanded]="activeIndex === $index">
                            {{ formatNavLabel(hdr.headerTitle) }}
                            <i class="sidenav-chevron fa-solid fa-chevron-down"
                               [class.sidenav-chevron--open]="activeIndex === $index"></i>
                        </button>
                        @if (activeIndex === $index) {
                            <ul class="dotcom-mobile-nav__sub-list">
                                @for (col of hdr.columns; track col.columnTitle) {
                                    @for (navItem of col.navItems; track navItem.link.href) {
                                        <li class="dotcom-mobile-nav__sub-item">
                                            <a class="dotcom-mobile-nav__sub-link"
                                               [appLink]="navItem.link | cmsUrl:cmsLocale"
                                               [target]="navItem.openTab ? '_blank' : '_self'"
                                               (click)="navigate()">
                                                {{ navItem.label }}
                                            </a>
                                            @if (navItem.subtitle) {
                                                <span class="dotcom-mobile-nav__subtitle">{{ navItem.subtitle }}</span>
                                            }
                                        </li>
                                    }
                                }
                            </ul>
                        }
                    </li>
                <!-- Contentstack link entry: a single navigation link with no sub-items -->
                } @else if (section.link; as lnk) {
                    <li class="dotcom-mobile-nav__item dotcom-mobile-nav__item--link">
                        <a class="dotcom-mobile-nav__link"
                           [appLink]="lnk.link | cmsUrl:cmsLocale"
                           [target]="lnk.openInTab ? '_blank' : '_self'"
                           (click)="navigate()">
                            {{ formatNavLabel(lnk.label) }}
                        </a>
                    </li>
                }
            }
        </ul>
    }
<!-- Non-CMS markets: nav items come from TEAS translation keys (menu.0-5.{url,name,target}) -->
} @else {
    <ul class="dotcom-mobile-nav">
        @for (item of menuItems; track item.url) {
            <!-- "Shop" override: replaces the cart landing link with a collapsible accordion item for the Shop sub-nav -->
            @if (isShopUrl(item.url)) {
                <li class="dotcom-mobile-nav__item">
                    <button class="dotcom-mobile-nav__trigger"
                            type="button"
                            (click)="toggleSection(-1)"
                            [attr.aria-expanded]="activeIndex === -1">
                        {{ item.name | uppercase }}
                        <i class="sidenav-chevron fa-solid fa-chevron-down"
                           [class.sidenav-chevron--open]="activeIndex === -1"></i>
                    </button>
                    @if (activeIndex === -1) {
                        <shop-nav-full-menu [mobile]="true" (closeMenu)="navigate()"></shop-nav-full-menu>
                    }
                </li>
            <!-- Standard translated nav link -->
            } @else {
                <li class="dotcom-mobile-nav__item dotcom-mobile-nav__item--link">
                    <a class="dotcom-mobile-nav__link"
                       [appLink]="item.url"
                       [target]="item.target || '_self'"
                       (click)="navigate()"
                       [attr.data-testid]="'dotcom-mobile-nav-' + item.url.split('/').pop()"
                       [innerHTML]="item.name | uppercase"></a>
                </li>
            }
        }
    </ul>
}
